import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { COMPANY, NAV_ITEMS } from '../../data/siteData';
import FloatingButtons from '../ui/FloatingButtons';
import Footer from './Footer';
import Navbar from './Navbar';

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(location.pathname !== '/' || window.scrollY > 50);

    // Ensure navbar state is correct on first render and when navigating between pages.
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [location.pathname]);

  const mapNavToPath = (item) => {
    const mapping = {
      Home: '/',
      About: '/about',
      Services: '/services',
      Projects: '/projects',
      Team: '/team',
      Contact: '/contact',
    };
    return mapping[item] || '/';
  };

  const handleNavigate = (item) => {
    setMobileMenuOpen(false);
    const path = mapNavToPath(item);
    if (location.pathname === '/' && path === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    navigate(path);
  };

  const handleConsult = () => {
    const cleanPhone = COMPANY.whatsapp.replace(/\D/g, '');
    const text = 'Namaste, mujhe aapse consultation chahiye.';
    try {
      const { openWhatsApp } = require('../../utils/whatsapp');
      openWhatsApp(cleanPhone, text);
      return;
    } catch (e) {
      const encoded = encodeURIComponent(text);
      const apiLink = `https://api.whatsapp.com/send?phone=${cleanPhone}&text=${encoded}`;
      const webLink = `https://web.whatsapp.com/send?phone=${cleanPhone}&text=${encoded}`;
      const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isMobile) {
        window.location.href = apiLink;
        return;
      }
      window.open(webLink, '_blank', 'noopener,noreferrer');
    }
  };

  const handleWhatsAppClick = () => {
    const message = 'Namaste RAVINDRAA Home & Decor, mujhe aapse apni property/decor ke regarding baat karni hai.';
    const cleanPhone = COMPANY.whatsapp.replace(/\D/g, '');
    try {
      const { openWhatsApp } = require('../../utils/whatsapp');
      openWhatsApp(cleanPhone, message);
      return;
    } catch (e) {
      const encodedText = encodeURIComponent(message);
      const apiLink = `https://api.whatsapp.com/send?phone=${cleanPhone}&text=${encodedText}`;
      const webLink = `https://web.whatsapp.com/send?phone=${cleanPhone}&text=${encodedText}`;
      const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isMobile) {
        window.location.href = apiLink;
        return;
      }
      window.open(webLink, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <>
      <Navbar
        company={COMPANY}
        navItems={NAV_ITEMS}
        isScrolled={isScrolled}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        activeSection={''}
        onNavigate={handleNavigate}
        onConsult={handleConsult}
      />

      <main className={location.pathname === '/' ? 'pt-0' : 'pt-28'}>
        <Outlet />
      </main>

      <FloatingButtons
        instagramLink={COMPANY.instagramLink}
        onWhatsAppClick={handleWhatsAppClick}
        isHidden={mobileMenuOpen}
      />

      <Footer company={COMPANY} onNavigate={handleNavigate} />
    </>
  );
};

export default Layout;
